import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../layout/layout.module';
import { ComponentsModule } from '../../components/components.module';
import { EncarregadoRoutingModule } from './encarregado-routing.module';
import { ApontamentoComponent } from './apontamento/apontamento.component';
import { PontoComponent } from './ponto/ponto.component';
import { DashboardEncarregadoComponent } from './dashboard-encarregado/dashboard-encarregado.component';
import { AdvertenciaComponent } from './advertencia/advertencia.component';
import { CadastrarEpiComponent } from './cadastrar-epi/cadastrar-epi.component';
import { ListagemEpiComponent } from './listagem-epi/listagem-epi.component';
import { AssociarEpiComponent } from './associar-epi/associar-epi.component';
import { CriarApontamentoComponent } from './criar-apontamento/criar-apontamento.component';
import { ListagemAjustesComponent } from './listagem-ajustes/listagem-ajustes.component';

@NgModule({
  declarations: [
    ApontamentoComponent,
    CriarApontamentoComponent,
    PontoComponent,
    DashboardEncarregadoComponent,
    AdvertenciaComponent,
    CadastrarEpiComponent,
    ListagemEpiComponent,
    AssociarEpiComponent,
    ListagemAjustesComponent,
  ],
  imports: [
    CommonModule,
    EncarregadoRoutingModule,
    ComponentsModule,
    LayoutModule,
  ],
  exports: [],
})
export class EncarregadoModule {}
